import React, { useEffect } from 'react';
import useFetch from '../../hooks/useFetch';
import { useParams } from 'react-router';
import config from '../../config';
import PageWrapper from '../../components/Invoice/PageWrapper';
import { CustomerIcon } from '../../components/SVGIcons/SVGIcons';

export default function TeamCustomerDetails() {
	const params = useParams();
	let customerUuid = params.customerUuid;

	const { data, fetch } = useFetch();

	useEffect(() => {
		fetch(`${config.apiv1}/customer/customer.read/${customerUuid}`);
	}, [customerUuid]);

	return (
		<PageWrapper
			header={{
				icon: <CustomerIcon />,
				text: 'Customer details',
				theme: 'sale',
			}}>
			<div className='customerDetails'>
				{data ? (
					<>
						<h3 className='marginBottom-40'>{data.name}</h3>

						<div className='dataRow'>
							<p>Email: </p>
							<h4>{data.email}</h4>
						</div>
						<div className='dataRow'>
							<p>GDC Number: </p>
							<h4>{data.gdc}</h4>
						</div>
						<div className='dataRow'>
							<p>Orders placed:</p>
							<h4>{data.ordersPlaced}</h4>
						</div>

						{data?.customerOnBehalfOfUsers?.length !== 0 && (
							<>
								<h4 className='marginTop-20'>Users ordered on behalf of</h4>
								<div className='list'>
									{data?.customerOnBehalfOfUsers?.map((behalfOfUser) => (
										<div className='listItem'>{behalfOfUser.name}</div>
									))}
								</div>
							</>
						)}

						{data?.customerTeams?.length !== 0 && (
							<>
								<h4 className='marginTop-20'>Teams</h4>
								<div className='list'>
									{data?.customerTeams &&
										data?.customerTeams?.map((team) => (
											<div className='listItem'>{team.teamName}</div>
										))}
								</div>
							</>
						)}
					</>
				) : (
					<></>
				)}
			</div>
		</PageWrapper>
	);
}
